export enum MESSAGE_TYPE {
  TEXT = 'TEXT',
  IMAGE = 'IMAGE',
  FILE = 'FILE',
  GIF = 'GIF',
  AUDIO = 'AUDIO',
  VIDEO = 'VIDEO',
  EVENT = 'EVENT'
}

export enum CHAT_STATUS {
  SENT = 'SENT',
  SEEN = 'SEEN'
}
